import Itaku from '@/Hyoutei/Itaku/ItakuApp.vue';
import Home from './templates/ItakuHome.vue';

export default {
    path: '/itaku',
    component: Itaku,
    children: [
        {
            path: '',
            component: Home,
        },
    ],
};
